// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnPIP6WPFLUBBIUl5z5k {
  position: relative;
  top: -20px;
  background: var(--grey-color-10);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
}

.Wr0MS1rZFFqd3rfvzVBf {
  display: flex;
  min-width: 2px;
  align-items: center;
  gap: 2px;
  flex: 1 0 0;
  width: 100%;
}

.ejlp92MvJAPlkPX6Iojw {
  width: 67px;
  height: 10px;
  border-radius: 5px;
}

.BMhfQgjtTutG_TaXHAn_ {
  width: 182px;
}

.K1u0mYb0P711qI9EdTBU {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  height: 10px;
}

.bGIOwSMuY4Fetsf9moLE {
  position: absolute;
  background: var(--grey-color-10);
  height: 100%;
  top: 0px;
  left: 100%;
}

.muoUH6CiaBjoySyWj2g1 {
  position: absolute;
  background: var(--grey-color-10);
  height: 100%;
  top: 0px;
  right: 100%;
}

.GlH9n4YpcqLc4kFqzUFk {
  border-radius: 10px;
  background: var(--grey-color-200);
  padding: 16px 32px;
}

.F9EPi7eAkje7D0BwL4pj {
  border-radius: 10px;
  background: var(--background-color);
  padding: 32px;
}

.uk0B3RwHIIoLkQ9VgdoS {
  border-radius: 10px;
  background: var(--background-color);
  padding: 32px;
  padding: 32px 0 32px 32px;
}

.S9n_XXl6ZpeJ2lSZ5nNr {
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-70);
}

.TvQAh4YO1T5jGRmqlwfU {
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-70);
  margin-top: 16px;
}

.hNQ6mAFNTY3YWJCJRLqY {
  display: flex;
  flex-direction: column;
}

.CHbVllus_QGRHNPjBt9x {
  position: absolute;
  width: 100%;
}

.vhFpI0HGzqdGZ3REk9Zi {
  display: grid;
  grid-auto-flow: column;
  padding-right: 48px;
}

.UYj102XpmFFi4a3oQMfV {
  display: grid;
  grid-auto-flow: column;
  justify-content: end;
  align-items: center;
  padding-top: 4px;
  margin-right: 32px;
}

.TifEVeMglYca6jKFR0_c {
  width: 14px;
  height: 14px;
  border: 1px solid;
  border-radius: 14px;
  margin: 4px 8px;
}

.oiZXJGjSGaNuJHFvjuAs {
  width: 54px;
  height: 24px;
  margin: 0 10px;
}

.a7pjcXCOrvid0kGUECF3 {
  width: 1px;
  height: 18px;
  background-color: var(--grey-gradient-end-color-10);
}

.dfg7NqtiMbgMoiwwCeNu {
  width: 100%;
  padding-top: 32px;
}

.u0FZaL04Sitrm97hn4WO {
  position: relative;
  top: 6px;
  left: 6px;
  font: 500 20px/29px var(--font-stack-full-medium);
}

.F2OGqTpvXoiKW511Fpbe {
  width: 120px;
}

.c05VjfAPvRPZnEkTUO4d {
  font-weight: 800;
}

.J8cRvD77tPigPnBsdA6Z {
  font-weight: 500;
}

.UsFc3GY3_07WS5NA8jmI {
  margin-right: 32px;
}

.TZD8RcNlm39r5S5EuLNk {
  line-height: 20px;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-stack-full-medium);
  padding: 0 4px;
}

.C6oBkjMsRf5iNYF0f8GJ {
  margin: 0;
  font-size: 14px;
  font-family: var(--font-stack-full-heavy);
  font-weight: 800;
  color: var(--grey-color-90);
}

.NvZ5Y8lFZVx3PkOps_UI {
  font-family: var(--font-stack-full-medium);
  font-size: 14px;
  font-weight: 500;
  color: var(--grey-color-70);
  margin: 0 0 16px 0;
  line-height: 20px;
  font-style: normal;
}

.SvcRF3C9PghoEMCfoEOW {
  margin: 0;
  padding-left: 16px;
  margin-bottom: 18px;
}
.SvcRF3C9PghoEMCfoEOW li::marker {
  font-size: 20px;
}

.TrY_e_3QmZWSpkaEaKWo {
  padding-top: 2px;
}

.LNdsKGOpSFNMiGyZDAr4 {
  display: flex;
  gap: 8px;
  padding: 12px 8px;
}

.cnUbUITJxWe6PP01Ds7j {
  margin-top: 3px;
}

.FlMvqNC4ve3pqOKLhlbr {
  margin: 16px 0;
}

.JPwaZahsXR7r6Xvx3bTQ {
  display: flex;
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/pages/CohortInsightsReportPages/CohortInsightsReportPages.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AACF;;AAeA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAZF;;AAeA;EACE,YAAA;AAZF;;AAeA;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAZF;;AAeA;EAjCE,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,QAAA;EAgCA,UAAA;AATF;;AAYA;EAtCE,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,QAAA;EAqCA,WAAA;AANF;;AASA;EACE,mBAAA;EACA,iCAAA;EACA,kBAAA;AANF;;AASA;EAvDE,mBAAA;EACA,mCAAA;EACA,aAAA;AAkDF;;AAOA;EA3DE,mBAAA;EACA,mCAAA;EACA,aAAA;EA2DA,yBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,2BAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,2BAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAFF;;AAKA;EACE,UAAA;EACA,YAAA;EACA,mDAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iDAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;AAFF;;AAKA;EACE,SAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;AAFF;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,oBAAA;AAFF","sourcesContent":[".tabContent {\n  position: relative;\n  top: -20px;\n  background: var(--grey-color-10);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 32px;\n}\n\n@mixin section {\n  border-radius: 10px;\n  background: var(--background-color);\n  padding: 32px;\n}\n\n@mixin side {\n  position: absolute;\n  background: var(--grey-color-10);\n  height: 100%;\n  top: 0px;\n}\n\n.rangeArray {\n  display: flex;\n  min-width: 2px;\n  align-items: center;\n  gap: 2px;\n  flex: 1 0 0;\n  width: 100%;\n}\n\n.longBubble {\n  width: 67px;\n  height: 10px;\n  border-radius: 5px;\n}\n\n.firstHeading {\n  width: 182px;\n}\n\n.spreadContainer {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  width: 100%;\n  height: 10px;\n}\n\n.right {\n  @include side;\n  left: 100%;\n}\n\n.left {\n  @include side;\n  right: 100%;\n}\n\n.disclaimer {\n  border-radius: 10px;\n  background: var(--grey-color-200);\n  padding: 16px 32px;\n}\n\n.factors {\n  @include section;\n}\n\n.bubbles {\n  @include section;\n  padding: 32px 0 32px 32px;\n}\n\n.LevelledFrameworkBodyContentContainer {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-70);\n}\n\n.bottomTrailerContainer {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-70);\n  margin-top: 16px;\n}\n\n.leaderDistChartContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.leaderDistChartFloatContainer {\n  position: absolute;\n  width: 100%;\n}\n\n.leaderDistChartHeaderContainer {\n  display: grid;\n  grid-auto-flow: column;\n  padding-right: 48px;\n}\n\n.leaderDistChartHeaderSub {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: end;\n  align-items: center;\n  padding-top: 4px;\n  margin-right: 32px;\n}\n\n.levelCircle {\n  width: 14px;\n  height: 14px;\n  border: 1px solid;\n  border-radius: 14px;\n  margin: 4px 8px;\n}\n\n.levelText {\n  width: 54px;\n  height: 24px;\n  margin: 0 10px;\n}\n\n.verticalDivider {\n  width: 1px;\n  height: 18px;\n  background-color: var(--grey-gradient-end-color-10);\n}\n\n.leaderDistChartStyle {\n  width: 100%;\n  padding-top: 32px;\n}\n\n.bubblesTitle {\n  position: relative;\n  top: 6px;\n  left: 6px;\n  font: 500 20px/29px var(--font-stack-full-medium);\n}\n\n.levelledLegendColumValueRanges {\n  width: 120px;\n}\n\n.levelledLegendColumValueTitles {\n  font-weight: 800;\n}\n\n.levelledLegendColumValueDesc {\n  font-weight: 500;\n}\n\n.bubbleChartButton {\n  margin-right: 32px;\n}\n\n.rangeNumber {\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: var(--font-stack-full-medium);\n  padding: 0 4px;\n}\n\n.legendChildHeaders {\n  margin: 0;\n  font-size: 14px;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 800;\n  color: var(--grey-color-90);\n}\n\n.legendContentParagraph {\n  font-family: var(--font-stack-full-medium);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--grey-color-70);\n  margin: 0 0 16px 0;\n  line-height: 20px;\n  font-style: normal;\n}\n\n.legendPointUnorderedList {\n  margin: 0;\n  padding-left: 16px;\n  margin-bottom: 18px;\n  li::marker {\n    font-size: 20px;\n  }\n}\n\n.leaderCountContainer {\n  padding-top: 2px;\n}\n\n.informationGrayContainer {\n  display: flex;\n  gap: 8px;\n  padding: 12px 8px;\n}\n\n.infoIconContainer {\n  margin-top: 3px;\n}\n\n.noteContainer {\n  margin: 16px 0;\n}\n\n.copyRightContainer {\n  display: flex;\n  justify-content: end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `UnPIP6WPFLUBBIUl5z5k`,
	"rangeArray": `Wr0MS1rZFFqd3rfvzVBf`,
	"longBubble": `ejlp92MvJAPlkPX6Iojw`,
	"firstHeading": `BMhfQgjtTutG_TaXHAn_`,
	"spreadContainer": `K1u0mYb0P711qI9EdTBU`,
	"right": `bGIOwSMuY4Fetsf9moLE`,
	"left": `muoUH6CiaBjoySyWj2g1`,
	"disclaimer": `GlH9n4YpcqLc4kFqzUFk`,
	"factors": `F9EPi7eAkje7D0BwL4pj`,
	"bubbles": `uk0B3RwHIIoLkQ9VgdoS`,
	"LevelledFrameworkBodyContentContainer": `S9n_XXl6ZpeJ2lSZ5nNr`,
	"bottomTrailerContainer": `TvQAh4YO1T5jGRmqlwfU`,
	"leaderDistChartContainer": `hNQ6mAFNTY3YWJCJRLqY`,
	"leaderDistChartFloatContainer": `CHbVllus_QGRHNPjBt9x`,
	"leaderDistChartHeaderContainer": `vhFpI0HGzqdGZ3REk9Zi`,
	"leaderDistChartHeaderSub": `UYj102XpmFFi4a3oQMfV`,
	"levelCircle": `TifEVeMglYca6jKFR0_c`,
	"levelText": `oiZXJGjSGaNuJHFvjuAs`,
	"verticalDivider": `a7pjcXCOrvid0kGUECF3`,
	"leaderDistChartStyle": `dfg7NqtiMbgMoiwwCeNu`,
	"bubblesTitle": `u0FZaL04Sitrm97hn4WO`,
	"levelledLegendColumValueRanges": `F2OGqTpvXoiKW511Fpbe`,
	"levelledLegendColumValueTitles": `c05VjfAPvRPZnEkTUO4d`,
	"levelledLegendColumValueDesc": `J8cRvD77tPigPnBsdA6Z`,
	"bubbleChartButton": `UsFc3GY3_07WS5NA8jmI`,
	"rangeNumber": `TZD8RcNlm39r5S5EuLNk`,
	"legendChildHeaders": `C6oBkjMsRf5iNYF0f8GJ`,
	"legendContentParagraph": `NvZ5Y8lFZVx3PkOps_UI`,
	"legendPointUnorderedList": `SvcRF3C9PghoEMCfoEOW`,
	"leaderCountContainer": `TrY_e_3QmZWSpkaEaKWo`,
	"informationGrayContainer": `LNdsKGOpSFNMiGyZDAr4`,
	"infoIconContainer": `cnUbUITJxWe6PP01Ds7j`,
	"noteContainer": `FlMvqNC4ve3pqOKLhlbr`,
	"copyRightContainer": `JPwaZahsXR7r6Xvx3bTQ`
};
export default ___CSS_LOADER_EXPORT___;
